<div class="main-container">
  <h2 class="page-header">API Credentials</h2>
  <!-- PAY10 admin: merchant search bar (top) -->
  <div class="search-container merchant-search-container" *ngIf="role === Role.PAY10_ADMIN">
    <div class="search-input-wrapper">
      <ng-container *ngIf="validatedMerchant; else searchInput">
        <span class="merchant-chip-text">{{ validatedMerchant.merchantName }} ({{ validatedMerchant.merchantId }})</span>
        <i class="pe-7s-close search-icon clear-icon" role="button"
           (click)="clearMerchantSearch()" aria-label="Clear merchant"></i>
      </ng-container>
      <ng-template #searchInput>
        <input type="text" class="search-input"
               placeholder="Search by Merchant Name or Merchant ID"
               [(ngModel)]="merchantSearchQuery"
               aria-label="Search merchants">
        <i *ngIf="merchantSearchQuery" class="pe-7s-close search-icon clear-icon"
           role="button" (click)="clearMerchantSearch()"></i>
        <i class="pe-7s-search search-icon"
           role="button" (click)="searchMerchant()"></i>
      </ng-template>
    </div>
    <div class="field-error" *ngIf="merchantError">
      <span class="error-icon">!</span>
      <span>{{ merchantError }}</span>
    </div>
  </div>

  <ng-container *ngIf="role !== Role.PAY10_ADMIN || validatedMerchant">
    <!-- Generate Button -->
    <div class="toolbar">
      <div class="toolbar-right" *ngIf="apiKeys.length > 0">
        <button class="generate-button" (click)="onGenerateApiKey()">
          Generate API Key
        </button>
      </div>
    </div>

    <!-- Search Bar (filter loaded keys) -->
    <div class="search-container" *ngIf="apiKeys.length > 0">
      <div class="search-input-wrapper">
        <input 
          type="text" 
          class="search-input" 
          placeholder="Search by label or key..."
          [(ngModel)]="searchQuery"
          (input)="applySearch()"
          aria-label="Search API keys">
        <i class="pe-7s-search search-icon"></i>
      </div>
    </div>

    <!-- API Key Display Banner -->
    <div class="api-key-display" *ngIf="showCredentialBanner">
      <button class="banner-close-btn" (click)="closeBanner()" aria-label="Close banner">
        <i class="pe-7s-close"></i>
      </button>
      <div class="api-key-row">
        <div class="api-key-item">
          <span class="api-key-label">API Key</span>
          <div class="api-key-value-wrapper">
            <span class="api-key-value" [title]="newAPIKey" [attr.data-value]="newAPIKey">{{ newAPIKey }}</span>
            <button class="api-key-copy-btn" (click)="copyToClipboard('newAPIKey')" aria-label="Copy API key">
              <img *ngIf="!copyedAPIKey" src="assets/icons/copy-blue.svg" alt="Copy API Key">
              <img *ngIf="copyedAPIKey" src="assets/icons/tick.svg" alt="Copyed API Key">
            </button>
          </div>
        </div>
        <div class="api-key-item">
          <span class="api-key-label">API Secret</span>
          <div class="api-key-value-wrapper">
            <span class="api-key-value" [title]="newAPISecret" [attr.data-value]="newAPISecret">{{ newAPISecret }}</span>
            <button class="api-key-copy-btn" (click)="copyToClipboard('newAPISecret')" aria-label="Copy API secret">
              <img *ngIf="!copyedAPISecret" src="assets/icons/copy-blue.svg" alt="Copy API Secret">
              <img *ngIf="copyedAPISecret" src="assets/icons/tick.svg" alt="Copyed API Secret">
            </button>
          </div>
        </div>
        <div class="api-key-actions">
          <button class="api-key-download-btn" (click)="downloadApiKey()" aria-label="Download API Key">
            Download API Key
            <img src="assets/icons/download-active.svg" alt="Download" />
          </button>
        </div>
      </div>
    </div>

  </ng-container>

  <!-- API Keys Table (always visible; overlay hidden until admin searches) -->
  <div class="card">
    <div class="ag-grid-container">
      <div class="ag-theme-alpine">
        <ag-grid-angular
          style="width: 100%; height: 100%;"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef" 
          [rowData]="apiKeys"
          [suppressPaginationPanel]="true" 
          [suppressRowClickSelection]="true"
          [rowSelection]="'multiple'" 
          [theme]="'legacy'"
          [getRowId]="getRowId" 
          (gridReady)="onGridReady($event)"
          [enableCellTextSelection]="true" 
          [suppressDragLeaveHidesColumns]="true" 
          [suppressMovableColumns]="false"
          [overlayNoRowsTemplate]="noRowsTemplate"
          [gridOptions]="gridOptions">
        </ag-grid-angular>
      </div>
    </div>
  </div>
</div>
  

<!-- DateTime Picker Dialog -->
<app-datetime-picker
  [(isVisible)]="isDateTimePickerVisible"
  [position]="dateTimePickerPosition"
  [minValidDate]="minValidDate"
  [minValidTime]="minValidTime"
  [maxValidDate]="maxValidDate"
  [maxValidTime]="maxValidTime"
  (apply)="handleDateTimeApply($event)"
  (closed)="handleDateTimeDialogClose()">
</app-datetime-picker>

<!-- OTP Validation Dialog -->
<app-otp-validation-dialog
  [(isVisible)]="isOtpDialogVisible"
  [title]="'Enter OTP'"
  [description]="'To verify your account, please enter the one-time password sent to your email.'"
  (submit)="handleOtpSubmit($event)"
  (closed)="handleOtpDialogClose()">
</app-otp-validation-dialog>
